import { navigate } from '@reach/router';
import { SEARCH_PANEL_GET_QUOTE_SEARCH_SELECTION_BEHAVIOR } from '../../components/searchPanel/graphql/__generated__/SEARCH_PANEL_GET_QUOTE_SEARCH_SELECTION_BEHAVIOR';

export default (data: any | undefined) => {
  if (
    !data?.hasMigratedPolicy?.location ||
    !data?.hasMigratedPolicy?.type
  ) {
    console.error('Could not determine quote behavior');
    return null;
  }
  const {
    type: behaviorType,
    location: behaviorLocation
  }: {
    type: string | null;
    location: string | null;
  } = data?.hasMigratedPolicy;
  switch (behaviorType) {
    case 'navigate':
      navigate(behaviorLocation!);
      break;
    case 'redirect':
      window.open(behaviorLocation!, '_self');
      break;
    default:
      break;
  }
  return null;
};
